module.exports = __webpack_public_path__ + "static/team-9-26bcace01c7f8f8f61025106e0185445.jpg";